import ApiService from '../apiservice'

export default class TriagemPublicacaoService extends ApiService {
  constructor() {
    super('/triagem-publicacoes');
  }

  listarPendentes(usuarioId) {
    return this.get(`/pendentes/${usuarioId}`);
  }

  consultar(codigo) {
    return this.get(`/${codigo}`);
  }

  designar(codigo, designacao) {
    return this.put(`/${codigo}/designar`, designacao);
  }
}
